import React from 'react'

export interface ResourceCategory {
  id: string
  title: string
  types: {
    id: string
    title: string
  }[]
}
export const ResourceCategoryContext = React.createContext(
  [] as ResourceCategory[]
)
